import React, { useEffect, useState } from 'react';
import { getStoredUser } from '../utils/authUser';
import { Link, useLocation } from 'react-router-dom';
import { ANALYTICS_PREFERENCE_EVENT, disableAnalytics, syncStoredAnalyticsUser, getAnalyticsPrivacyState, isAnalyticsPublicPath, setAnalyticsPreference, trackContactClick, trackPageView } from '../services/analyticsService';
import './WebsiteAnalytics.css';

export default function WebsiteAnalytics() {
  const location = useLocation();
  const [privacy, setPrivacy] = useState(getAnalyticsPrivacyState);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const update = () => setPrivacy(getAnalyticsPrivacyState());
    window.addEventListener(ANALYTICS_PREFERENCE_EVENT, update);
    return () => window.removeEventListener(ANALYTICS_PREFERENCE_EVENT, update);
  }, []);
  useEffect(() => {
    // Let route metadata settle; the cleanup avoids duplicate StrictMode page views.
    const timer = window.setTimeout(() => {
      const user = getStoredUser();
      if (getAnalyticsPrivacyState().gpc) disableAnalytics(user);
      else syncStoredAnalyticsUser(user);
      trackPageView();
    }, 0);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search, privacy.enabled]);
  useEffect(() => {
    const onClick = event => {
      const href = event.target.closest?.('a[href]')?.getAttribute('href') || '';
      if (href.startsWith('tel:')) trackContactClick('phone_click');
      if (href.startsWith('mailto:')) trackContactClick('email_click');
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);
  if (!isAnalyticsPublicPath(location.pathname)) return null;
  const choose = enabled => { setAnalyticsPreference(enabled); setOpen(false); };
  const noticeVisible = open || (!privacy.decided && !privacy.gpc);
  return <aside className="analytics-choices" aria-label="Website analytics choices">
    {noticeVisible && <div className="analytics-notice">
      <p>We use Google Analytics to understand visits and consultation requests. <Link to="/privacy-policy">Privacy policy</Link></p>
      {privacy.gpc ? <p>Your browser’s privacy signal has turned analytics off.</p> : <div><button type="button" onClick={() => choose(true)}>Keep analytics on</button><button type="button" onClick={() => choose(false)}>Turn off analytics</button></div>}
      {open && <button type="button" onClick={() => setOpen(false)}>Close</button>}
    </div>}
    <button type="button" className="analytics-choices-toggle" aria-expanded={noticeVisible} onClick={() => setOpen(!open)}>Privacy choices</button>
  </aside>;
}
